import type { Theme } from '@soteria/design-system-ve';
import { getSystemThemePreference } from '@soteria/design-system-ve';

/**
 * Gets the theme to use based on localStorage and system preference
 * Priority: localStorage > system preference > default ('dark')
 * @returns The theme to use
 */
export function getInitialTheme(): Theme {
  // Check localStorage first
  try {
    if (typeof localStorage === 'undefined') {
      return getSystemThemePreference();
    }

    const savedTheme = localStorage.getItem('theme');

    // Validate that the saved theme is actually a valid Theme type
    if (savedTheme === 'dark' || savedTheme === 'light') {
      return savedTheme;
    }
  } catch (e) {
    // Handle potential exceptions from localStorage access
    // (e.g., in private browsing mode or when storage is disabled)
    if (e instanceof DOMException) {
      // Fallback to system preference if localStorage is not accessible
      return getSystemThemePreference();
    }

    // Re-throw unexpected exceptions (non-DOMException errors)
    throw e;
  }

  // No saved theme or invalid theme, use system preference
  return getSystemThemePreference();
}
